import IDataFilterDescriptor from "../IDataFilterDescriptor";
import IDataFilterEnumCheckBoxHandler from "./IDataFilterEnumCheckBoxHandler";
import IDataFilterEnumValue from "./IDataFilterEnumValue";

export default class DataFilterEnumCheckBoxHandler
  implements IDataFilterEnumCheckBoxHandler {
  setDescriptorValuesToUrlParams(
    descriptor: IDataFilterDescriptor,
    urlParams: URLSearchParams
  ) {
    urlParams.delete(descriptor.name);
    (descriptor.value as IDataFilterEnumValue[])
      .filter((x) => x.value)
      .forEach((value) => {
        urlParams.append(descriptor.name, value.key);
      });
  }

  setDescriptorValuesFromUrlParams(
    descriptor: IDataFilterDescriptor,
    urlParams: URLSearchParams
  ) {
    const storeValues = urlParams.getAll(descriptor.name);
    (descriptor.value as IDataFilterEnumValue[]).forEach((value) => {
      value.value = storeValues.includes(value.key);
    });
  }
}
